import axios from 'axios';
import { DiveElement } from '../../data_types';

const BASE_URL = process.env.REACT_APP_DEEP_DIVE_BASE_URL as string;

if (!BASE_URL) {
    throw new Error('REACT_APP_DEEP_DIVE_BASE_URL is not defined in the environment variables');
}

export const fetchDiveElements = async (): Promise<{ headline: string; elements: DiveElement[] }> => {
    try {
        const response = await axios.get<{ headline: {id: number, headline: string}; elements: DiveElement[] }>(BASE_URL, {
            withCredentials: true // Include credentials in the request
        });
        const {headline, elements} = response.data;
        return {
            headline: headline.headline,
            elements
        }
    } catch (error: any) {
        console.error('Failed to fetch dive elements:', error.message);
        throw new Error('Failed to fetch dive elements');
    }
};

export const addDiveElement = async (newDiveElement: DiveElement): Promise<DiveElement> => {
    try {
        const response = await axios.post<DiveElement>(BASE_URL, newDiveElement, {
            withCredentials: true // Include credentials in the request
        });
        return response.data;
    } catch (error) {
        throw new Error('Failed to add dive element');
    }
};
